import React, { Component, useEffect, useState } from 'react';
import ScrollRight from '../../scroll/ScrollRight';
import ScrollLeft from '../../scroll/ScrollLeft';
import windowSize from 'react-window-size';
import ArticleCard from './ArticleCard';
import i18next from 'i18next';
class ArticlesCards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            click: 0,
            scroll: 0,
            start: 0,
            end: 5,
            width: this.props.windowWidth,
            article: '',
            image: '',
            articles: [],
        };
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.setEnd();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        this.setEnd();
    }

    end = () => {
        if (this.state.width > 1350) {
            return 5;
        } else if (this.state.width <= 1350 && this.state.width > 900) {
            return 5;
        } else if (this.state.width <= 990 && this.state.width > 480) {
            return 5;
        } else if (this.state.width <= 480) {
            return 2;
        }
    };

    setEnd = () => {
        this.setState({
            end: this.end(),
        });
    };

    scroll = () => {
        if (this.state.width > 990) {
            return 330;
        } else if (this.state.width <= 990 && this.state.width > 500) {
            return 190;
        } else if (this.state.width <= 500 && this.state.width > 200) {
            return 190;
        }
    };

    clickEnd = () => {
        if (this.state.width > 1350) {
            return 3;
        } else if (this.state.width <= 1350 && this.state.width > 900) {
            return 3;
        } else if (this.state.width <= 990 && this.state.width > 480) {
            return 3;
        } else if (this.state.width <= 480) {
            return 3;
        }
    };

    handleLeftClick = () => {
        this.setState({
            click: this.state.click + 1,
            scroll: this.state.scroll + this.scroll(),
            start: this.state.start + 1,
            end: this.state.end + 1,
        });
    };

    handleRightClick = () => {
        this.setState({
            click: this.state.click - 1,
            scroll: this.state.scroll - this.scroll(),
            start: this.state.start - 1,
            end: this.state.end - 1,
        });
    };

    render() {
        let classname = `${
            this.state.width < 1100
                ? `disable-${this.state.start} disable-${this.state.end}`
                : ''
        }`;
        // Get all articles and map
        let cards = this.props.articles
            .slice(0, `${this.props.size}`)
            .map((article) => (
                <div
                    key={article.id}
                    className={`white-card ${
                        this.props.small ? '' : `${classname}`
                    }`}
                >
                    <ArticleCard
                        article={article}
                        title={article.title}
                        en_title={article.en_title}
                        image={article.image}
                        file={article.file}
                        article={article.article}
                    />
                </div>
            ));
        let displayedCards = cards.splice(0, this.state.end);
        return (
            <div
                className={`articles-container-old ${
                    this.props.small ? 'activity-container-small' : ''
                }`}
            >
                {/* Don't show arrows if property small was passed */}
                {this.props.small || this.state.width > 1100 ? (
                    <></>
                ) : (
                    <div className='arrows-container'>
                        <div className='arrow-right'>
                            <div
                                className={`${
                                    this.state.click === 0 ? 'invisible' : ''
                                }`}
                                onClick={this.handleRightClick}
                            >
                                <ScrollRight />
                            </div>
                        </div>
                        <div
                            className='arrow-left'
                            onClick={this.handleLeftClick}
                        >
                            <div
                                className={`${
                                    this.state.click ===
                                        this.props.articles.length - 1 ||
                                    this.state.click === this.clickEnd()
                                        ? 'invisible'
                                        : ''
                                }`}
                            >
                                <ScrollLeft />
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className={`activities-cards article-cards activities-cards-small ${
                        this.props.nowrap ? 'cards-nowrap' : ''
                    }`}
                    style={{
                        transform: `${
                            this.state.width < 1100
                                ? `translateX(${this.state.scroll}px)`
                                : ''
                        }`,
                        transition: 'transform 1s',
                    }}
                >
                    {displayedCards}
                </div>
            </div>
        );
    }
}

export default windowSize(ArticlesCards);
